<div class="flex-column hidden-overflow">
  <div class="dialog-title-row">
    @if (_data.iconType === "warning") {
      <span class="material-symbols-outlined warning-icon" align="center"
        >warning_amber</span
      >
    } @else if (_data.iconType === "info") {
      <span class="material-symbols-outlined info-icon" align="center"
        >info</span
      >
    } @else if (_data.iconType === "error") {
      <span class="material-symbols-outlined error-icon" align="center"
        >error</span
      >
    }
    <button mat-icon-button (click)="cancelClick()" class="close-icon">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  <mat-dialog-content class="dialog-content-align">
    <span [innerHTML]="_data.message"></span>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    @if (_data.singleButton) {
      <button mat-flat-button (click)="cancelClick()">
        {{ _data.confirmButtonText || "ok" | translate }}
      </button>
    } @else {
      <button mat-flat-button class="cancel-button" (click)="cancelClick()">
        {{ _data.cancelButtonText || "no" | translate }}
      </button>
      <button mat-flat-button (click)="confirmClick()">
        {{ _data.confirmButtonText || "yes" | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
